import { render } from "./oidc.vue?vue&type=template&id=6ec714ad&scoped=true"
import script from "./oidc.vue?vue&type=script&lang=js"
export * from "./oidc.vue?vue&type=script&lang=js"

import "./oidc.vue?vue&type=style&index=0&id=6ec714ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec714ad"]])

export default __exports__